export const CODEBOOKS_COLORS = [
  ['#76C893', '#C8E9D4'],
  ['#34A0A4', '#AED9DA'],
  ['#29ABE2', '#A9DDF3'],
  ['#1E6091', '#A5BFD3'],
  ['#00296B', '#99A9C4'],
  ['#25CED1', '#A8EBEC'],
  ['#FFBA08', '#FFE39C'],
  ['#FF7D00', '#FFCB99'],
  ['#D00000', '#EC9999'],
  ['#880D1E', '#CF9EA5'],
  ['#B23A48', '#E0B0B6'],
  ['#78290F', '#C9A99F'],
  ['#461220', '#B5A0A6'],
  ['#132A13', '#A1AAA1'],
  ['#31572C', '#ADBCAB'],
  ['#007F5F', '#99CCBF'],
  ['#90A955', '#D2DCBB'],
  ['#8AC926', '#D0E9A8'],
  ['#F84AA7', '#FCB6DC'],
  ['#B5179E', '#E1A2D8'],
  ['#A74482', '#DCB4CD'],
  ['#693668', '#C3AFC2'],
  ['#4B1281', '#B7A0CC'],
  ['#444444', '#B4B4B4']
]
